// users.js

import { users } from '../actions';

const initialDisplayCount = 6;
const displayCountIncrement = 6;

const initialState = {
  user: null,
  given_name: '',
  email: '',
  address: '',
  credits: 0,
  status: users.types.LOGGED_OUT,
  displayCountStatus: '',
  error: '',
  homeDisplayCount: initialDisplayCount,
  collectionDisplayCount: initialDisplayCount,
  libraryDisplayCount: initialDisplayCount,
  setDisplayCount: initialDisplayCount,
  notificationStatus: false
};

const user_reducers = (state, action) => {
  if (typeof state === 'undefined') return initialState;
  let newstate;

  switch (action.type) {
    case users.types.LOGGED_OUT:
      return { ...initialState, displayCount: state.displayCount };
    case users.types.LOGGING_IN:
    case users.types.GETTING_DETAILS:
    case users.types.SHOW_LOGIN:
    case users.types.SHOW_REGISTER:
    case users.types.REGISTERING:
    case users.types.PROMPTING_RECOVERY_EMAIL:
    case users.types.SENDING_RECOVERY_EMAIL:
    case users.types.SETTING_NEW_PASSWORD:
    case users.types.PROMPTING_CHANGE_PASSWORD:
    case users.types.CHANGING_PASSWORD:
      return { ...state, status: action.type };
    case users.types.CHANGE_PASSWORD:
    case users.types.SET_NEW_PASSWORD:
      return {
        ...state,
        status: action.type,
        notificationStatus: 'passwordReset'
      };
    case users.types.SAVING:
      return {
        ...state,
        status: action.type,
        notificationStatus: 'changeUserDetails'
      };
    case users.types.RESET_NOTIFICATION_STATUS:
      return { ...state, notificationStatus: false };
    case users.types.LOGIN_FAILED:
    case users.types.REGISTER_FAILED:
    case users.types.SENDING_RECOVERY_EMAIL_FAILED:
    case users.types.SETTING_NEW_PASSWORD_FAILED:
    case users.types.CHANGE_PASSWORD_FAILED:
    case users.types.GET_CREDITS_FAILED:
      return { ...state, status: action.type, error: action.error };
    case users.types.DISPLAYING_MORE:
      return { ...state, displayCountStatus: action.type };
    case users.types.DISPLAY_MORE_FAILED:
      return { ...state, displayCountStatus: action.type, error: action.error };
    case users.types.LOGGED_IN:
      newstate = {
        status: action.type,
        user: action.user
      };
      return { ...state, ...newstate };
    case users.types.GOT_DETAILS:
      newstate = {
        status: action.type,
        ...action
      };
      delete newstate['type'];
      return { ...state, ...newstate };
    case users.types.GOT_CREDITS:
      newstate = {
        credits: action.credits
      };
      return { ...state, ...newstate };
    case users.types.SENT_RECOVERY_EMAIL:
      newstate = {
        status: action.type,
        email: action.email
      };
      return { ...state, ...newstate };
    case users.types.DISPLAY_MORE:
      newstate = {
        displayCountStatus: action.type,
        [action.page + 'DisplayCount']:
          state[action.page + 'DisplayCount'] + displayCountIncrement
      };
      return { ...state, ...newstate };
    default:
      return state;
  }
};

export default user_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/users.js